module.exports = "a{\r\n    display:inline-block;\r\n    margin:0 10px;\r\n    color: white;\r\n    text-decoration: none;\r\n  }\r\n\r\n\r\n "